const initialState = {
  activities: { "EN-US": [], "ES-MX": [] },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_CLASSPROGRESS_STATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
